const couponsDictEN = {
  specialCustomerRegisterCoupons: "Credit Coupons",
  generateCoupon: "Invitation coupon",
  extracoinAmount: "Amount of Extracredit credit",
  unexpectedErrorWhileGeneratingCoupon: "Unexpected error while generating credit coupon.",
  currency: "Currency",
  used: "Used",
  notUsed: "Not used",
  couponGenerated: "You generated a new credit coupon successfully!",
  couponCanceled: "You canceled the operation to generate a new credit coupon",
  areYouSureCoupon:
    "Are you sure you want to generate a new credit coupon? The amount will be debited from your Extracredit balance.",
  confirmYourAction: "Confirm your action",
  confirm: "Confirm",
  usedBy: "Used by",
  generatedCoupon: "Generated coupon",
  inviteCouponDialogTitle: "Invitation coupon creation",
  inviteCouponDialogSubtitle: "Send extra welcome credits.",
  inviteCouponSectionBalance: "Extracredit balance",
  inviteCouponSectionData: "Coupon details",
  inviteCouponAmountLabel: "Enter amount",
  inviteCouponAmountTooltip: "Amount debited from your Extracredit balance when the coupon is created.",
  inviteCouponAmountHint: "Use up to {balance} ECR",
  inviteCouponBelowMinBalance: "Minimum balance to create a coupon is {min} ECR.",
  inviteCouponCreating: "Please wait while we create the coupon.",
  inviteCouponCancel: "Cancel",
  inviteCouponCreate: "Create coupon",
  inviteCouponSuccessTitle: "Coupon created",
  inviteCouponSuccessMeta: "Success • {dateTime}",
  inviteCouponYouUsed: "You used",
  inviteCouponCodeSection: "Coupon code",
  inviteCouponShareHint:
    "Share this code with your invitee. They will receive {couponValue} in ECR as soon as they register. This code can only be used once.",
  inviteCouponFinish: "Done",
  inviteCouponErrorGeneric: "Could not create the coupon. Please try again.",
};

export default couponsDictEN;
